/**
 * 处理高级查询中快捷显示
 */
import createFormConverterUtil from '../../../static/js/createFormConverterUtil'
export default function setByShortcutFormCriteriaFormDef(criteriaFormDefData, callback, vue) {
  var inputComponentArray = ['input', 'inputnumber', 'selectRemote']
  var dateComponentArray = ['pangudatepicker', 'datepicker']
  var newitems = []
  var items = criteriaFormDefData.items

  var onOkFunction = (event) => {
    callback?.()
    if (event && event.preventDefault) event.preventDefault()
  }
  if (items) {
    for (var i = 0; i < items.length; i++) {
      var item = items[i]
      if (item.shortcut) {
        var newitem = Object.assign({}, item)
        if (!newitem.parameter) {
          newitem.parameter = {}
        }
        newitem.parameter.placeholder = item.label
        newitem.label = null // 快捷查询时，不显示lable
        if (!newitem.style) {
          newitem.style = {}
        }
        if (
          newitem.component &&
          (newitem.component.code == 'input' || newitem.component.code == 'Input') &&
          !newitem.style.width
        ) {
          newitem.style.width = '260px'
        }
        if (!newitem.style.marginRight) newitem.style.marginRight = '15px'
        newitems.push(newitem)
        // 默认按下回车键时触发【输入框类组件】
        newitem.event = {
          // 按下回车键时触发
          'on-enter': onOkFunction,
        }

        // 时间范围响应on-ok事件
        if (
          newitem.component &&
          newitem.component.code &&
          newitem.parameter &&
          newitem.parameter.type == 'datetimerange' &&
          dateComponentArray.indexOf(newitem.component.code.toLowerCase()) != -1
        ) {
          newitem.event['on-ok'] = onOkFunction
          newitem.event['on-clear'] = onOkFunction
        } else if (
          newitem.component &&
          newitem.component.code &&
          inputComponentArray.indexOf(newitem.component.code.toLowerCase()) == -1
        ) {
          // 其他组件，响应on-change
          // console.log("!inputComponentArray.indexOf",newitem.component.code);
          //  newitem.event['on-ok']=onOkFunction;
          newitem.event['on-change'] = onOkFunction
        }
        // 为input添加on-clear事件
        else if (newitem.component && newitem.component.code === 'input') {
          newitem.event['on-clear'] = onOkFunction
        }
        items.splice(i, 1)
        i = i - 1
      }
    }
  }
  if (newitems.length > 0) newitems[newitems.length - 1].style.marginRight = '0'

  newitems = createFormConverterUtil.converterItems(newitems)
  // 兼容老模式直接返回列表
  var formItems = newitems
  // 只显示可见表单元素
  return createFormConverterUtil.getItemsForFilterVisible(formItems, null, vue)
}
